import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseURL, getUser } from "../redux/Action";
import { AiFillGithub } from "react-icons/ai";
import { FcGoogle } from "react-icons/fc";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Footer from "../Components/v1/Footer";

const Login = () => {
  const { isAuth } = useSelector((state) => state);
  const [signin, setSignin] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Blogshog | System Access";
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSignin({
      ...signin,
      [name]: value,
    });
  };

  if (isAuth) {
    return <Navigate to={"/"} />;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const id = toast.loading("Authenticating...", { theme: "dark" });
    axios
      .post(`${baseURL}/signin`, signin, { withCredentials: true })
      .then((res) => {
        if (res.status === 201) {
          toast.update(id, {
            render: res.data.status,
            type: "success",
            isLoading: false,
            theme: "dark",
            autoClose: 2000,
            closeOnClick: true,
          });
          localStorage.setItem("jwtoken", res.data.token);
          localStorage.setItem("refreshToken", res.data.refreshToken);
          getUser(dispatch);
          navigate("/");
        }
      })
      .catch((err) => {
        toast.update(id, {
          render: "Invalid Authorization",
          type: "error",
          isLoading: false,
          theme: "dark",
          autoClose: 2000,
          closeOnClick: true,
        });
      });
  };

  return (
    <div className="flex flex-col min-h-screen bg-white dark:bg-black text-black dark:text-white">
      <div className="flex-1 flex flex-col md:flex-row mt-[73px] bg-white dark:bg-black ">
        {/* Left Typography Block */}
        <div className="w-full md:w-1/2 p-8 md:p-16 border-b md:border-b-0 md:border-r border-black dark:border-white/30 flex flex-col justify-between bg-[#f4f4f4] dark:bg-[#0a0a0a] relative overflow-hidden">
          <div className="absolute top-0 right-0 p-8 text-[15vw] md:text-[10vw] font-black leading-none text-black/5 dark:text-white/5 select-none pointer-events-none -mt-10 tracking-tighter mix-blend-multiply dark:mix-blend-normal">
            AUTH
          </div>

          <div className="z-10 relative">
            <span className="inline-block border border-black dark:border-white/30 px-3 py-1 text-[10px] font-mono font-bold tracking-widest uppercase mb-8 bg-white dark:bg-[#111] text-black dark:text-white shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)]">
              SYS.INF.03 — Access
            </span>
            <h1 className="text-5xl lg:text-7xl font-black uppercase tracking-tighter leading-[0.9] mb-4 text-black dark:text-white">
              AUTHORIZE
              <br />
              IDENTITY
            </h1>
            <p className="mt-8 text-xs font-mono tracking-widest leading-relaxed max-w-sm text-gray-700 dark:text-gray-300 font-bold uppercase">
              Authenticate your identity credentials to enter the operator
              dashboard and initiate architectural drafting.
            </p>
          </div>

          <div className="hidden md:block z-10 text-[10px] font-mono tracking-widest text-gray-500 dark:text-gray-400 mt-20 uppercase font-bold">
            <span className="text-red-500 dark:text-red-400">WARNING:</span>{" "}
            UNAUTHORIZED ACCESS PROHIBITED.
          </div>
        </div>

        {/* Right Form Block */}
        <div className="w-full md:w-1/2 p-8 md:p-16 flex flex-col justify-center bg-white dark:bg-black relative">
          <form
            className="w-full max-w-md mx-auto relative z-10"
            onSubmit={handleSubmit}
          >
            <div className="mb-8">
              <label
                htmlFor="email"
                className="block text-xs font-bold font-mono tracking-widest uppercase text-black dark:text-white mb-2"
              >
                Operator Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                onChange={handleChange}
                className="w-full px-4 py-4 rounded-none border border-black dark:border-white/30 bg-white dark:bg-[#111] placeholder-gray-400 dark:placeholder-gray-500 text-black dark:text-white font-mono focus:outline-none focus:ring-0 focus:bg-gray-50 dark:focus:bg-[#1a1a1a] transition-all sm:text-sm shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] focus-visible:shadow-none dark:focus-visible:shadow-none focus-visible:translate-x-1 focus-visible:translate-y-1"
                placeholder="identification@domain.com"
              />
            </div>

            <div className="mb-10">
              <label
                htmlFor="password"
                className="block text-xs font-bold font-mono tracking-widest uppercase text-black dark:text-white mb-2"
              >
                Security Key
              </label>
              <div className="relative">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  autoComplete="current-password"
                  required
                  onChange={handleChange}
                  className="w-full px-4 py-4 rounded-none border border-black dark:border-white/30 bg-white dark:bg-[#111] placeholder-gray-400 dark:placeholder-gray-500 text-black dark:text-white font-mono focus:outline-none focus:ring-0 focus:bg-gray-50 dark:focus:bg-[#1a1a1a] transition-all sm:text-sm shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] focus-visible:shadow-none dark:focus-visible:shadow-none focus-visible:translate-x-1 focus-visible:translate-y-1"
                  placeholder="••••••••"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-1 pr-4 flex items-center text-black dark:text-gray-400 hover:text-red-600 dark:hover:text-red-400 transition-colors bg-transparent border-none"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <FaEyeSlash className="h-5 w-5" />
                  ) : (
                    <FaEye className="h-5 w-5" />
                  )}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="w-full py-4 px-4 border border-black dark:border-white/30 text-sm font-black font-mono tracking-widest uppercase text-white dark:text-black bg-black dark:bg-white hover:bg-white hover:text-black dark:hover:bg-black dark:hover:text-white transition-colors shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] active:shadow-none dark:active:shadow-none active:translate-x-1 active:translate-y-1"
            >
              Initiate Handshake
            </button>

            <div className="mt-12 mb-8 flex items-center justify-center space-x-4">
              <div className="w-full h-px bg-black dark:bg-white"></div>
              <span className="text-[10px] uppercase font-mono tracking-widest font-bold whitespace-nowrap text-black dark:text-white">
                External Providers
              </span>
              <div className="w-full h-px bg-black dark:bg-white"></div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <a
                href={`https://github.com/login/oauth/authorize?client_id=${process.env.REACT_APP_CLIENTID}`}
                className="w-full flex items-center justify-center px-4 py-3 border border-black dark:border-white/30 bg-white dark:bg-[#111] text-xs font-black font-mono tracking-widest uppercase text-black dark:text-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)] active:shadow-none active:translate-x-0.5 active:translate-y-0.5"
              >
                <AiFillGithub className="h-5 w-5 mr-2" />
                GitHub
              </a>

              <a
                href={`https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=https%3A%2F%2Ffull-stack-blog-application-mu.vercel.app%2Fauth%2Fgoogle%2Fcallback&client_id=${process.env.REACT_APP_GOOGLE_CLIENTID}&response_type=code&prompt=consent&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email`}
                className="w-full flex items-center justify-center px-4 py-3 border border-black dark:border-white/30 bg-white dark:bg-[#111] text-xs font-black font-mono tracking-widest uppercase text-black dark:text-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)] active:shadow-none active:translate-x-0.5 active:translate-y-0.5"
              >
                <FcGoogle className="h-5 w-5 mr-2 bg-white rounded-full p-0.5 border border-black dark:border-white/30" />
                Google
              </a>
            </div>

            <p className="mt-12 text-center text-[10px] font-mono tracking-widest uppercase font-bold text-gray-500 dark:text-gray-400">
              No clearance?{" "}
              <Link
                to="/signup"
                className="text-black dark:text-white border-b border-black dark:border-white/30 hover:text-red-600 dark:hover:text-red-400 hover:border-red-600 dark:hover:border-red-400 transition-colors ml-2"
              >
                Establish Protocol
              </Link>
            </p>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
